import { storage } from "./storage";
import { attendeeSendData } from "../api";
import accessAPI from "../api/accessAPI";

let routerInstance = null;
let pendingPushData = null;

if (typeof window !== 'undefined') {
  window.median_onesignal_push_opened = function(data) {
    if (!routerInstance) {
      pendingPushData = data;
      return;
    }

    processPushClick(data);
  };
}

export function initOneSignal(attendeeId, router) {
  if (typeof window === 'undefined' || !window.median) return;

  routerInstance = router;

  if (pendingPushData) {
    const data = pendingPushData;
    pendingPushData = null;

    processPushClick(data);
  }

  setTimeout(async () => {
    try {
      if (window.median.onesignal?.onesignalInfo) {
        const info = await window.median.onesignal.onesignalInfo();

        if (info?.oneSignalId) {
          await attendeeSendData(`/api/v2/attendees/${attendeeId}/device`, {
            device_id: info.oneSignalId
          });
        }
      }
    } catch (e) {
      console.error('[OneSignal] Device registration error', e);
    }
  }, 1500);
}

function processPushClick(data) {
  try {
    const payload = data.additionalData || data;
    const conferenceId = payload.conference_id;

    if (conferenceId) {
      handleConferenceSwitch(conferenceId);
    }
  } catch (e) {
    console.error('[OneSignal] processPushClick error', e);
  }
}

async function handleConferenceSwitch(conferenceId) {
  try {
    const res = await accessAPI.authorizeUserByEvent(conferenceId);

    const token = res.data?.data?.token;
    const attendeeId = res.data?.data?.attendee_id;

    if (!token || !attendeeId) {
      throw new Error('Missing token or attendeeId in response');
    }

    await storage.setItem('token', token);
    await storage.setItem('attendee_id', String(attendeeId));

    // Повне перезавантаження сторінки - гарантує правильну ініціалізацію
    window.location.href = `/conference/attendee/${attendeeId}/dash`;
  } catch (err) {
    console.error('[OneSignal] handleConferenceSwitch error', e);

    // При помилці — редірект на Event Switcher
    window.location.href = `/conference/attendee/events-switcher`;
  }
}
